import React, { useState } from 'react';
import { Layout, Row, Col, Form, Input, Button, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import * as authService from './authService';

const { Content } = Layout;

const ForgotPassword = () => {
  const [step, setStep] = useState('request'); // 'request' or 'confirm'
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onRequestCode = async (values) => {
    setLoading(true);
    try {
      await authService.forgotPassword(values.email);
      setEmail(values.email);
      setStep('confirm');
      message.success('비밀번호 재설정 코드가 이메일로 전송되었습니다');
    } catch (err) {
      console.error('Forgot password error:', err);
      const msg = err.response?.data?.message || err.message || '코드 전송에 실패했습니다';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const onConfirmReset = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.warning('비밀번호가 일치하지 않습니다');
      return;
    }
    setLoading(true);
    try {
      await authService.confirmForgotPassword(email, values.code, values.newPassword);
      message.success('비밀번호가 변경되었습니다. 로그인해주세요.');
      window.location.href = '/login';
    } catch (err) {
      console.error('Reset password error:', err);
      const msg = err.response?.data?.message || err.message || '비밀번호 변경에 실패했습니다';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', padding: '25px' }}>
      <Content>
        <Row>
          <Col span={8} offset={8}>
            <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>
              비밀번호 찾기
            </h2>

            {step === 'request' && (
              <Form name="forgot_password" onFinish={onRequestCode}>
                <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                  가입한 이메일 주소를 입력하면 비밀번호 재설정 코드가 전송됩니다.
                </p>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: '이메일을 입력하세요' }]}
                >
                  <Input prefix={<MailOutlined />} placeholder="이메일" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading}>
                    재설정 코드 전송
                  </Button>
                </Form.Item>
              </Form>
            )}

            {step === 'confirm' && (
              <Form name="reset_password" onFinish={onConfirmReset}>
                <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                  {email}로 전송된 코드와 새 비밀번호를 입력해주세요.
                </p>
                <Form.Item
                  name="code"
                  rules={[{ required: true, message: '인증 코드를 입력하세요' }]}
                >
                  <Input prefix={<LockOutlined />} placeholder="인증 코드" maxLength={6} />
                </Form.Item>
                <Form.Item
                  name="newPassword"
                  rules={[
                    { required: true, message: '새 비밀번호를 입력하세요' },
                    { min: 8, message: '비밀번호는 8자 이상이어야 합니다' },
                  ]}
                >
                  <Input type="password" prefix={<LockOutlined />} placeholder="새 비밀번호 (8자 이상)" />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  rules={[{ required: true, message: '비밀번호 확인을 입력하세요' }]}
                >
                  <Input type="password" prefix={<LockOutlined />} placeholder="새 비밀번호 확인" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading}>
                    비밀번호 변경
                  </Button>
                </Form.Item>
              </Form>
            )}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ForgotPassword;
